export const faqGroups = [
  {
    category: '参与与资格',
    icon: 'ri-user-add-line',
    items: [
      {
        q: '需要什么样的账号才能参加爆瓜福利活动？',
        a: '只要完成基础账号注册并绑定常用手机号即可参与大部分活动。部分涉及实物奖励的活动会额外要求填写收货信息，这类要求都会在活动详情页提前标注，不会在最后一步才临时通知。',
      },
      {
        q: '同一台设备可以参与多个账号的活动吗？',
        a: '不建议。系统会识别同一设备、同一网络下的异常多账号行为，若被判定为异常参与，相关奖励会被回收。正常家庭多人使用不同账号一般不受影响。',
      },
      {
        q: '参与活动需要付费吗？',
        a: '不需要。爆瓜福利汇总的活动均为免费参与，任何以「缴纳费用才能领奖」为由的要求都与本平台无关，请务必提高警惕，不要向陌生账号转账。',
      },
    ],
  },
  {
    category: '任务与奖励',
    icon: 'ri-award-line',
    items: [
      {
        q: '任务完成后奖励什么时候到账？',
        a: '签到、浏览类任务通常即时到账；涉及人工审核的投稿与精选评论，一般在采纳后 24 小时内发放；邀请类奖励统一在次日结算。你可以在「我的福利」里查看每一笔奖励的状态与到账时间。',
      },
      {
        q: '为什么我的任务显示完成但没有奖励？',
        a: '常见原因有三种：一是任务仍在审核中，状态会显示为「待发放」；二是当天该任务已达到次数上限；三是任务存在异常行为被系统拦截。遇到前两种情况耐心等待即可，第三种可以在「常见问题」页的反馈入口联系我们核实。',
      },
      {
        q: '瓜豆有什么用，会过期吗？',
        a: '瓜豆是站内通用的奖励计量单位，可用于抽奖、兑换专区换好物或兑换优惠券。瓜豆自获得之日起 12 个月内有效，临近过期前会在个人中心提醒，建议及时使用。',
      },
      {
        q: '连续签到中断了，之前的记录会清零吗？',
        a: '不会清零，但连签进度会重新计算。已经发放到账的瓜豆不受影响，中断后从第 1 天重新开始累计，满 7 天依然可以再次获得满勤加码奖励。',
      },
    ],
  },
  {
    category: '抽奖与概率',
    icon: 'ri-trophy-line',
    items: [
      {
        q: '抽奖结果是怎么产生的？',
        a: '每次抽奖都由系统在完整奖池中随机产生结果，每次抽取相互独立，不受前后次数影响。奖品数量、剩余库存与中奖概率均在玩法与规则页公示，活动期间同步更新。',
      },
      {
        q: '抽奖券用完了还能继续抽吗？',
        a: '可以继续获取。抽奖券主要来源为签到、任务完成与限时活动发放，券有独立有效期，过期未使用会自动失效，建议在有效期内尽快使用。',
      },
      {
        q: '抽到实物奖品后怎么领取？',
        a: '中奖后请在个人中心填写收货信息，信息提交后不可自行修改。实物奖品一般在信息确认后的 10 个工作日内发出，偏远地区可能顺延，物流单号会同步到中奖记录中。',
      },
    ],
  },
  {
    category: '账号与安全',
    icon: 'ri-shield-check-line',
    items: [
      {
        q: '忘记密码或者账号异常登录怎么办？',
        a: '可在登录页使用绑定手机号找回密码。若发现账号在非本人设备上有登录记录，请第一时间修改密码并检查绑定信息，同时通过反馈邮箱联系我们协助处理。',
      },
      {
        q: '遇到冒充客服要求提供验证码的情况怎么办？',
        a: '我们的工作人员不会主动索要验证码、密码或要求转账。遇到此类情况请直接忽略并举报，必要时通过官方邮箱核实身份，切勿向任何人透露验证码。',
      },
    ],
  },
];